import React, { Fragment } from 'react';
import { FieldValidationErrors } from './field-validation-errors';
import { Label } from './label';
const Checkbox = (props) => {
    const { field, value, onChange, tracker, errors } = props;
    return (React.createElement(Fragment, null,
        React.createElement(Label, Object.assign({}, props),
            React.createElement("input", { type: "checkbox", className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, value: "true", checked: value, onChange: (e) => handleOnChange(field, e.target.checked, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) })),
        React.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {boolean} fieldValue
 * @param {FieldChangeCallback} callback
 */
function handleOnChange(field, fieldValue, callback) {
    // (fieldName, fieldValue, isValid, validationErrors)
    callback(field.valueField.name, fieldValue, true, []);
}
export default Checkbox;
